import useSWR from 'swr';
import 'whatwg-fetch';

const fetcher = url => fetch(url, { credentials: 'same-origin' })
  .then(res => res.json());

const useCompanionProfile = (companionProfile, pollingInterval) => {
  const {
    data,
    error,
  } = useSWR('/hq.json', {
    fetcher,
    initialData: companionProfile,
    refreshInterval: pollingInterval,
  });

  return {
    companionProfile: data,
    isLoading: (!data && !error),
    error,
  };
};

export default useCompanionProfile;
